module.exports = __webpack_public_path__ + "img/3.038e46f0.png";